import useSchedulingEligibilities from '@hooks/useSchedulingEligibilities'

import useLeavePrompt from './LeavePrompt.hooks'

/**
 * Asks the browser to confirm closing or leaving the site while the patient can still book,
 * which a non-empty eligibility list means. Never fires on in-app navigation, and never inside
 * the native app, which runs its own reminders.
 */
export default function NeedsBookingPrompt() {
  const eligibilities = useSchedulingEligibilities()

  useLeavePrompt({
    source: 'needsBooking',
    when: window.isNativeApp !== true && eligibilities.length > 0,
    blocksNavigation: false,
  })

  return null
}
